/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyTypeItemDto
 */
export interface PropertyTypeItemDto {
    /**
     * Property type ID
     * @type {number}
     * @memberof PropertyTypeItemDto
     */
    id: number;
    /**
     * Property type name
     * @type {string}
     * @memberof PropertyTypeItemDto
     */
    propertyType: string;
}

/**
 * Check if a given object implements the PropertyTypeItemDto interface.
 */
export function instanceOfPropertyTypeItemDto(value: object): value is PropertyTypeItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('propertyType' in value) || value['propertyType'] === undefined) return false;
    return true;
}

export function PropertyTypeItemDtoFromJSON(json: any): PropertyTypeItemDto {
    return PropertyTypeItemDtoFromJSONTyped(json, false);
}

export function PropertyTypeItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyTypeItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'propertyType': json['propertyType'],
    };
}

export function PropertyTypeItemDtoToJSON(json: any): PropertyTypeItemDto {
    return PropertyTypeItemDtoToJSONTyped(json, false);
}

export function PropertyTypeItemDtoToJSONTyped(value?: PropertyTypeItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'propertyType': value['propertyType'],
    };
}

